import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {

  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className="wrap">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-md d-flex align-items-center pt-2 pb-2">
              <p className="mb-0 phone">
                <span className="mailus">Phone no:</span>{" "}
                <a href="tel:+64220866040">+64 02 202 36511</a> or{" "}
                <span className="mailus">Email:</span>{" "}
                <a href="mailto:info@clearandclean.co.nz">
                  info@clearandclean.co.nz                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar ftco-navbar-light">
        <div className="container">

          <Link className="navbar-brand" to="/" onClick={closeMenu}>
            <img src="/images/clean_logo.png" alt="Clear & Clean"  style={{width:"270px"}}/>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
          >
            <span className="fa fa-bars"></span> 
          </button>

          <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`} id="ftco-nav">
            <ul className="navbar-nav ml-auto">

              <li className={`nav-item ${isActive("/") ? "active" : ""}`}>
                <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
              </li>

              <li className={`nav-item ${isActive("/why-choose-us") ? "active" : ""}`}>
                <Link to="/#why-choose-us" className="nav-link" onClick={closeMenu}>Why Choose us</Link>
              </li>

              <li className={`nav-item ${isActive("/about") ? "active" : ""}`}>
                <Link to="/about" className="nav-link" onClick={closeMenu}>About Us</Link>
              </li>

              <li className={`nav-item ${isActive("/services") ? "active" : ""}`}>
                <Link to="/services" className="nav-link" onClick={closeMenu}>Services</Link>
              </li>

              <li className={`nav-item ${isActive("/blog") ? "active" : ""}`}>
                <Link to="/blog" className="nav-link" onClick={closeMenu}>Blog</Link>
              </li>

              <li className={`nav-item ${isActive("/reviews") ? "active" : ""}`}>
                <Link to="/reviews" className="nav-link" onClick={closeMenu}>Reviews</Link>
              </li>

              <li className={`nav-item ${isActive("/faq") ? "active" : ""}`}>
                <Link to="/faq" className="nav-link" onClick={closeMenu}>FAQ</Link>
              </li>

              <li className={`nav-item ${isActive("/contact") ? "active" : ""}`}>
                <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>
              </li>

            </ul>
          </div>

        </div>
      </nav>
    </>
  );
}

export default Header;